import React, { Component, Fragment } from 'react';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import DrawerCustom from '../../components/DrawerCustom';

const styles = theme => ({
    boxItemContent: {
        padding: theme.spacing(4),
        marginBottom: theme.spacing(1.5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer',
        height:'100%',
        width:'100%'
    },
});
function PaymentForm (props) {
    let { classes, t, onClose, paymentFormData } = props
    if(paymentFormData){
        paymentFormData = paymentFormData.replace(`<div class="row">`,`<div>`)
    }
    // console.log("AAA paymentFormData:",paymentFormData);
    //var  xxx = "<html><body><form method='post' target='myframe' name='paymentForm' id='paymentForm' action='https://tjccpg.jccsecure.com/EcomPayment/RedirectAuthLink'><input type='hidden' name='Version' value='1.0.0'> <br><input type='hidden' name='MerID' value='0099080012'> <br><input type='hidden' name='AcqID' value='402971'> <br><input type='hidden' name='MerRespURL' value='https://sandbox.crm.com/backoffice/v1/jcc/add_cards/response/YzBkZDBkNmUtYjc3ZC00ZDU0LTk3MjAtZTZjYTRhNDE4ZmVh'> <br><input type='hidden' name='PurchaseAmt' value='000000000001'> <br><input type='hidden' name='PurchaseCurrency' value='978'> <br><input type='hidden' name='PurchaseCurrencyExponent' value='2'> <br><input type='hidden' name='OrderID' value='EKOREWARDSYzBkZDBkNmUtYjc3ZC00ZDU0LTk3MjAtZTZjYTRhNDE4ZmVh'> <br><input type='hidden' name='CaptureFlag' value='A'> <br><input type='hidden' name='trxType' value='R'> <br><input type='hidden' name='Signature' value='oYrB5Dgpt5JcpT6FJhBApgPRSxo='> <br><input type='hidden' name='SignatureMethod' value='SHA1'> <br></form><script language='Javascript'>document.forms['paymentForm'].submit();</script></body></html>"
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={onClose}
                //title={t('add_a_card')}
                enableBack
            >   
                {/* <iframe name="myframe" frameborder="0" width="700" height="500" title="some legacy app title" srcdoc={paymentFormData}>
                    
                </iframe> */}
                <div style={{width:'100%'}} dangerouslySetInnerHTML={{__html:paymentFormData}}/>
            
            </DrawerCustom>
        </div>
    );
}
export default withStyles(styles)(withTranslation()(PaymentForm));